import { Box, Button, ButtonBase, Dialog, DialogTitle, Fade, Modal, Typography } from "@mui/material"
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Translate, translate } from "react-i18nify";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";
import TimeUtils from "../../utils/TimeUtils";

export const TestResultBox = ({testResult, width}) => {
    const passed = testResult?.passed != null ? testResult?.passed : null

    const [open, setOpen] = useState(false)

    const handleClick = () => {
        setOpen(prev => !prev)
    }

    return (
        <Box  sx={{ width: width ?? "100%" }} >
        {/* <Box  sx={{ width: width ?? "100%" }} > */}
            <TestResultPopUp open={open} testResult={testResult} setOpen={setOpen} />
            <ButtonBase 
                onClick={handleClick} 
                color="test" 
                disabled={passed == null}
                sx={{ 
                    width:"100%", 
                    bgcolor: passed == null ? "" : passed === true ? "test.passed" : "test.failed",
                    "&:hover":
                        {
                            bgcolor: passed == null ? "" : passed === true ? "test.passedHover" : "test.failedHover"
                        }
                }} 
            >
                <TestResultPassedBox passed={passed} hasBGColor={false}/>
            </ButtonBase>
        </Box>
    )
}

export const TestResultPassedBox = ({passed, hasBGColor}) => {
    return (
        <Box 
        id={"TestResultPassedBox"}
        display={"flex"} flexDirection={"row"} 
        sx={{ 
            height:"100%", 
            bgcolor: !hasBGColor ? null : passed == null ? "" : passed === true ? "test.passed" : "test.failed", 
            justifyContent:"space-around" 
            }} >
            <Box display={"flex"} flexDirection={"row"}  sx={{ m:1 }}>
                <Box  >
                    <Typography > 
                        {passed == null ? "No test results" : passed === true ? translate("Passed") : translate("Failed")}
                    </Typography>
                </Box>
                <Box color={passed == null ? null : passed === true ? "test.passedIcon" : "test.failedIcon"} >
                    {passed == null ? null : passed === true ? <CheckIcon  /> : <CloseIcon/> }
                </Box>
            </Box>
        </Box>
    )
}

export const TestResultPopUp = ({testResult, open, setOpen}) => {
    const onClose = () => {
        setOpen(false)
    }

    const columns = [
        {
            field: 'TestCaseId', headerName: translate('TestCaseId', {id: ""}), flex:1, 
            valueGetter: (params) => {
                return params.row.caseId;
            }
        },
        {
            field: 'Value', headerName: translate('TestCaseValue'), flex: 1, 
            valueGetter: (params) => {
                return params.row.resultValue?.value;
            }
        },
        {
            field: 'Comment', headerName: translate('Comment'), flex: 1, 
            valueGetter: (params) => {
                return params.row.comment;
            }
            
        },
        {
            field: 'Passed', headerName: translate('Passed'), flex: 1, 
            renderCell: (params) => {
                return (
                    <Box sx={{width:"100%", height:"100%"}} >
                    <TestResultPassedBox passed={params.row?.passed} hasBGColor={true}/>
                    </Box>
                )
            },
            valueGetter: (params) => {
                return params.row.passed;
            }
            
        },
    ]
    return (
            <Dialog
            id={"testResultDialog"}
            open={open}
            onClose={() => onClose()}
            fullWidth
            maxWidth="md"
            sx={{ height:"100%", overflow: "hidden"}}
            >
                <DialogTitle sx={{mt:2}} >
                    <Box sx={{ mb:1}} >
                        <Typography variant="h5" >
                            <Translate value="TestProtocolName" tpName={testResult?.testProtocol}/>
                        </Typography>
                    </Box>
                    <Box sx={{ mb:1}} >
                        <Typography variant="h5" >
                            <Translate value="TestResultDialogUser" username={testResult?.username} userId={testResult?.userId}/>
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="h5" >
                            <Translate value="TimestampVal" time={TimeUtils.utcToLocal(testResult?.submitUnixTimestamp, true)}/>
                        </Typography>
                    </Box>
                </DialogTitle>
                <Box sx={{ m:5, height: 700, }} >
                    <Box sx={{height:"95%", }} >

                        <DataGrid
                            columns={columns}
                            rows={testResult?.testCases}
                            sx={{ height: "100%",
                                width: "100%",
                                ".MuiDataGrid-row":{
                                    border: 1,
                                    borderTop:0,
                                    borderLeft:0,
                                    borderRight:0
                                },
                                ".MuiDataGrid-columnHeader":{
                                    border: 1,
                                    borderTop:0,
                                    borderLeft:0,
                                    borderRight:0
                                }

                            }}
                            showCellRightBorder={true}
                            showColumnRightBorder={true}
                            rowSpacingType={"border"}
                            getRowId={(row) => {
                                return row.caseId
                            }}
                            />    
                    </Box>
                    <Box id="EquipmentUsed" width={"30%"} sx={{ py:3 }}   >
                        <Typography  variant="h6">
                            <Translate value="EquipmentUsed" />
                        </Typography>
                        {
                            testResult?.equipmentMetadata.map((em,i) => {
                                return (
                                    <Box sx={{ display:"flex", flexDirection:"row", borderBottom:2, mb:1, maxWidth:150 }} >
                                        <Box sx={{ mr:1, minWidth: 80 }} >
                                            <Typography variant="body" >
                                                { translate("EquipmentTypeIdValue", {value: em.typeId})}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography variant="body" >
                                                { translate("EquipmentIdValue", {value: em.id})}
                                            </Typography>
                                        </Box>
                                    </Box>
                                )
                            })
                        }
                    </Box>
                </Box>
            </Dialog>
    )
}